module.exports = __webpack_public_path__ + "img/2-2.85bf2d02.png";